import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import article1 from '../../photos/article1.jpg';
import article2 from '../../photos/article2.jpg';
import avatar1 from '../../photos/avatar1.jpg';
import avatar2 from '../../photos/avatar2.jpg';
import corporate1 from '../../photos/corporate1.jpg';
import corporate2 from '../../photos/corporate2.jpg';
import corporate3 from '../../photos/corporate3.jpg';
import corporate4 from '../../photos/corporate4.jpg';
import corporate5 from '../../photos/corporate5.jpg';
import alonaAvatar from '../../photos/alona-main.jpg';
import corporate6 from '../../photos/corporate6.jpg';
import corporate7 from '../../photos/corporate7.jpg';
import corporate8 from '../../photos/corporate8.jpg';
import corporate9 from '../../photos/corporate9.jpg';
import corporate10 from '../../photos/corporate10.jpg';
import event1 from '../../photos/2026-03-22 18.07.48.jpg';
import event2 from '../../photos/2026-03-22 18.08.08.jpg';
import event3 from '../../photos/2026-03-22 18.08.12.jpg';
import event4 from '../../photos/2026-03-22 18.08.16.jpg';
import event5 from '../../photos/2026-03-22 18.08.19.jpg';
import event6 from '../../photos/2026-03-22 18.08.22.jpg';
import event7 from '../../photos/2026-03-22 18.08.25.jpg';
import event8 from '../../photos/2026-03-22 18.08.28.jpg';
import event9 from '../../photos/2026-03-22 18.08.33.jpg';
import event10 from '../../photos/2026-03-22 18.08.37.jpg';
import event11 from '../../photos/2026-03-27 12.29.30.jpg';
import event12 from '../../photos/2026-03-27 12.29.40.jpg';
import event13 from '../../photos/2026-03-27 12.29.44.jpg';
import event14 from '../../photos/2026-03-27 12.29.47.jpg';
import event15 from '../../photos/2026-03-27 12.29.50.jpg';
import event16 from '../../photos/2026-03-27 12.29.53.jpg';
import event17 from '../../photos/2026-03-27 12.29.56.jpg';
import event18 from '../../photos/2026-03-27 12.29.59.jpg';

const articles = [
  {
    img: article1,
    avatar: avatar1,
    title: 'Як змінилося життя моєї фірми з появою якісної логістики',
    author: 'Сергій Каменецький',
    company: 'Директор компанії "Элмон спецсервіс"',
    shortText: 'Наша щільна співпраця з цією фірмою розпочалася у 2011р. До цього ми шукали машини на різних ресурсах типу Lardi-trans і т.п. Це займало дуже багато часу, зусиль та нервів у менеджерів нашої фірми. Початок співпраці з цією логістичною компанією все спростив...',
    fullText: `Наша щільна співпраця з цією фірмою розпочалася у 2011р. До цього ми шукали машини на різних ресурсах типу Lardi-trans і т.п. Це займало дуже багато часу, зусиль та нервів у менеджерів нашої фірми. Менеджери змушені були витрачати багато часу на пошук авто та оформлення документів з кожним перевізником окремо. Відповідно, залишалося менше часу на продаж та пошук нових клієнтів. Продаж не зростав.

Початок співпраці з цією логістичною компанією все спростив. Простий дзвінок, із зазначенням пункту вивантаження, вирішував проблему наявності потрібного автомобіля за кілька хвилин, максимум – кілька годин. Логісти підшукували автомобіль, а менеджер у цей час міг спокійно займатися продажем та пошуком нових клієнтів.

Як результат, оберти швидко збільшилися, нервова напруга спало (що теж важливо). Звичайно, ми розуміли, що переплачуємо кілька сотень гривень на кожному авто за послуги логістики, але ці витрати з лишком окупилися наростаючим продажем, оскільки замість однієї-двох машин на день ми почали відвантажувати 5-10.

Документообіг теж значно спростився. Замість десятків різних перевізників, із якими потрібно було обмінюватися кореспонденцією, з'явилася логістична компанія, яка швидко та легко надавала всі необхідні документи, т.ч. Бухгалтерія теж зітхнула з полегшенням...

Життя нашої фірми значно спростилася, завдяки появі надійного та якісного партнера. Зараз все працює як годинник - просто робиш заявку і займаєшся справою, в той час як логісти шукають потрібний автомобіль, бухгалтерія отримує первинку вчасно та без проблем.

«Скупий платить двічі» особливо часом, нервами та проблемами з документами. Ми вирішили не поскупитися і за це рішення огороджені сторицею.

Усім прибуткового бізнесу!`,
  },
  {
    img: article2,
    avatar: avatar2,
    title: 'Якісна логістика - це рух вперед',
    author: 'Олександр',
    company: 'Директор "Українська Агропромислова Група"',
    shortText: 'Ми це відчули ще у 2007 році. Завдяки тому, що команда "The Hot Logistics" взяла на себе повний контроль та супровід вантажу, наші менеджери відчули комфорт. Це 100% впевненість за цілісність вантажу. Ми отримали додатковий час на опрацювання нових клієнтів, що значно розширило нашу клієнтську базу.',
    fullText: `Якісна логістика - це рух вперед. Ми це відчули ще у 2007 році, коли про слово "outsourcing" мало хто чув. Завдяки тому, що команда "The Hot Logistics" взяла на себе повний контроль та супровід вантажу, наші менеджери відчули комфорт. Це 100% впевненість за цілісність вантажу. Ми отримали додатковий час на опрацювання нових клієнтів. Це значно розширило нашу клієнтську базу та збільшило наш дохід.

Відтоді ми пліч-о-пліч рухаємось вгору. За цей час сформувались довговічні та корисні відносини котрі ми будемо розвивати й надалі.

Найголовнішою рисою наших логістичних партнерів є швидке реагування на ситуації ринку автоперевезень та інформування менеджерів Української Агропромислової Групи. Це сприяє автоматизації продажів, та збільшує їх обсяг на 20-30%.`,
  },
  {
    img: corporate1,
    avatar: alonaAvatar,
    title: 'Наш корпоратив - коли логістика зупиняється, починається магія',
    author: 'Горяча Альона Юріївна',
    company: 'Директор The Hot Logistics',
    isCorporate: false,
    gallery: [
      { src: event1, wide: true },
      { src: event2, wide: false },
      { src: event3, wide: false },
      { src: event4, wide: true },
      { src: event5, wide: false },
      { src: event6, wide: false },
      { src: event7, wide: true },
      { src: event8, wide: false },
      { src: event9, wide: false },
      { src: event10, wide: true },
      { src: event11, wide: false },
      { src: event12, wide: false },
      { src: event13, wide: true },
      { src: event14, wide: false },
      { src: event15, wide: false },
      { src: event16, wide: true },
      { src: event17, wide: false },
      { src: event18, wide: false },
    ],
    shortText: 'Ми не просто колеги - ми команда, яка вміє і працювати, і відпочивати на повну. Наш корпоратив - це завжди атмосфера тепла, щирих емоцій та трішки божевілля.',
    fullText: `Хто сказав, що логісти тільки й роблять, що шукають машини та рахують тонни? Раз на рік ми доводимо, що вміємо набагато більше - організовувати незабутнє свято!

Наш корпоратив - це не просто вечірка. Це вечір, коли кожен може бути собою, коли директор бере мікрофон і стає ведучою, а менеджери перетворюються на зірок танцполу.

За роки роботи ми зрозуміли одну просту річ: сильна команда будується не тільки в офісі. Справжня хімія народжується, коли ти бачиш своїх колег з іншого боку - коли вони сміються, танцюють, дарують подарунки та просто кайфують від того, що вони разом.

Ми працюємо як одне ціле, тому що знаємо один одного не лише за робочим столом. І саме це робить The Hot Logistics не просто компанією, а сім'єю.

Дякуємо кожному, хто є частиною цієї команди. Ви - наша найцінніша "вантажівка", яка везе нас до успіху!`,
  },
];

function ArticlesNew() {
  const sectionRef = useRef(null);
  const [modalArticle, setModalArticle] = useState(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const cards = entry.target.querySelectorAll('.article-card');
            cards.forEach((card, i) => {
              setTimeout(() => {
                card.style.opacity = '1';
                card.style.transform = 'translateY(0)';
              }, i * 200);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (modalArticle) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => { document.body.style.overflow = ''; };
  }, [modalArticle]);

  return (
    <>
    <section ref={sectionRef} style={{
      padding: 'clamp(60px, 8vw, 120px) 24px',
      background: 'linear-gradient(180deg, #0a0a0f 0%, #0d1a0e 100%)',
    }}>
      <div style={{ maxWidth: 1300, margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(24px, 4vw, 40px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 60,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          Історії <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>успіху</span>
        </h2>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
          gap: 32,
        }}>
          {articles.map((article, i) => (
            <div key={i} className="article-card" style={{
              opacity: 0,
              transform: 'translateY(40px)',
              transition: 'all 0.7s cubic-bezier(0.4, 0, 0.2, 1)',
              borderRadius: 20,
              overflow: 'hidden',
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.06)',
              display: 'flex',
              flexDirection: 'column',
            }}>
              <div style={{
                height: 200,
                overflow: 'hidden',
                position: 'relative',
                flexShrink: 0,
              }}>
                <img src={article.img} alt="" style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover',
                }} />
                <div style={{
                  position: 'absolute',
                  inset: 0,
                  background: 'linear-gradient(0deg, rgba(10,10,15,1) 0%, transparent 60%)',
                }} />
              </div>
              <div style={{ padding: '24px 32px 32px', display: 'flex', flexDirection: 'column', flex: 1 }}>
                {!article.isCorporate && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 20 }}>
                    <img src={article.avatar} alt="" style={{
                      width: 50,
                      height: 50,
                      borderRadius: '50%',
                      objectFit: 'cover',
                      border: '2px solid rgba(22,183,36,0.3)',
                    }} />
                    <div>
                      <div style={{ color: '#fff', fontWeight: 600, fontSize: 15 }}>{article.author}</div>
                      <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13 }}>{article.company}</div>
                    </div>
                  </div>
                )}
                <h3 style={{
                  fontSize: 20,
                  fontWeight: 700,
                  color: '#fff',
                  marginBottom: 14,
                  lineHeight: 1.3,
                }}>
                  {article.title}
                </h3>
                <p style={{
                  fontSize: 14,
                  color: 'rgba(255,255,255,0.55)',
                  lineHeight: 1.7,
                  marginBottom: 20,
                }}>
                  {article.shortText}
                </p>
                <button
                  onClick={() => setModalArticle(article)}
                  style={{
                    marginTop: 'auto',
                    alignSelf: 'flex-start',
                    background: 'none',
                    border: '1px solid rgba(77,194,71,0.3)',
                    color: '#4dc247',
                    padding: '10px 24px',
                    borderRadius: 30,
                    fontSize: 14,
                    fontWeight: 500,
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                    letterSpacing: '0.02em',
                  }}
                  onMouseEnter={e => {
                    e.target.style.background = 'rgba(77,194,71,0.1)';
                    e.target.style.borderColor = '#4dc247';
                  }}
                  onMouseLeave={e => {
                    e.target.style.background = 'none';
                    e.target.style.borderColor = 'rgba(77,194,71,0.3)';
                  }}
                >
                  Показати весь текст
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 500px) {
          section > div > div:last-child {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </section>

    {/* Modal */}
    {modalArticle && ReactDOM.createPortal(
      <div
        onClick={() => setModalArticle(null)}
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 10000,
          background: 'rgba(0,0,0,0.8)',
          backdropFilter: 'blur(12px)',
          overflowY: 'auto',
          display: 'flex',
          justifyContent: 'center',
          padding: '40px 24px',
          animation: 'modalFadeIn 0.3s ease',
        }}
      >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: 'linear-gradient(180deg, #111518 0%, #0a0f0a 100%)',
              border: '1px solid rgba(77,194,71,0.15)',
              borderRadius: 24,
              maxWidth: 700,
              width: '100%',
              margin: 'auto 0',
              animation: 'modalSlideUp 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            {/* Modal header image */}
            <div style={{
              overflow: 'hidden',
              position: 'relative',
              borderRadius: '24px 24px 0 0',
            }}>
              <img src={modalArticle.img} alt="" style={{
                width: '100%',
                height: 'auto',
                display: 'block',
                maxHeight: 400,
                objectFit: 'cover',
              }} />
              <div style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(0deg, #111518 0%, transparent 70%)',
              }} />
              {/* Close button */}
              <button
                onClick={() => setModalArticle(null)}
                style={{
                  position: 'absolute',
                  top: 16,
                  right: 16,
                  width: 40,
                  height: 40,
                  borderRadius: '50%',
                  background: 'rgba(0,0,0,0.5)',
                  backdropFilter: 'blur(8px)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  color: '#fff',
                  fontSize: 20,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  transition: 'all 0.2s ease',
                }}
                onMouseEnter={e => e.target.style.background = 'rgba(77,194,71,0.3)'}
                onMouseLeave={e => e.target.style.background = 'rgba(0,0,0,0.5)'}
              >
                ✕
              </button>
            </div>

            {/* Modal content */}
            <div style={{ padding: '24px 40px 40px' }}>
              {!modalArticle.isCorporate && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
                  <img src={modalArticle.avatar} alt="" style={{
                    width: 56,
                    height: 56,
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '2px solid rgba(22,183,36,0.3)',
                  }} />
                  <div>
                    <div style={{ color: '#fff', fontWeight: 600, fontSize: 16 }}>{modalArticle.author}</div>
                    <div style={{ color: 'rgba(255,255,255,0.5)', fontSize: 14 }}>{modalArticle.company}</div>
                  </div>
                </div>
              )}
              <h3 style={{
                fontSize: 24,
                fontWeight: 700,
                color: '#fff',
                marginBottom: 24,
                lineHeight: 1.3,
              }}>
                {modalArticle.title}
              </h3>
              {modalArticle.fullText.split('\n\n').map((paragraph, idx) => (
                <p key={idx} style={{
                  fontSize: 15,
                  color: 'rgba(255,255,255,0.7)',
                  lineHeight: 1.8,
                  marginBottom: 16,
                }}>
                  {paragraph}
                </p>
              ))}

              {/* Photo Gallery for corporate article */}
              {modalArticle.gallery && (
                <div style={{ marginTop: 24 }}>
                  <div style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: '#4dc247',
                    textTransform: 'uppercase',
                    letterSpacing: '0.1em',
                    marginBottom: 16,
                  }}>
                    Фотогалерея
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                    {(() => {
                      const items = modalArticle.gallery;
                      const rows = [];
                      let i = 0;
                      while (i < items.length) {
                        if (items[i].wide) {
                          rows.push([items[i]]);
                          i++;
                        } else if (i + 1 < items.length && !items[i + 1].wide) {
                          rows.push([items[i], items[i + 1]]);
                          i += 2;
                        } else {
                          rows.push([items[i]]);
                          i++;
                        }
                      }
                      return rows.map((row, ri) => (
                        <div key={ri} style={{
                          display: 'flex',
                          gap: 12,
                        }}>
                          {row.map((photo, ci) => (
                            <div key={ci} style={{
                              flex: row.length === 1 ? '1' : '1 1 0',
                              borderRadius: 12,
                              overflow: 'hidden',
                            }}>
                              <img src={photo.src} alt="" style={{
                                width: '100%',
                                height: 'auto',
                                display: 'block',
                              }} />
                            </div>
                          ))}
                        </div>
                      ));
                    })()}
                  </div>
                </div>
              )}
            </div>
        </div>
      </div>,
      document.body
    )}

    <style>{`
      @keyframes modalFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      @keyframes modalSlideUp {
        from { opacity: 0; transform: translateY(30px) scale(0.97); }
        to { opacity: 1; transform: translateY(0) scale(1); }
      }
    `}</style>
    </>
  );
}

export default ArticlesNew;
